import { DynaStatus } from '@/types';
import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';

interface getDynamicDocumentsDataTableStructureProps {
  rowActions?: DataTableRowActions;
  createAction?: () => void;
}

export const getDynamicDocumentsDataTableStructure = ({ rowActions, createAction }: getDynamicDocumentsDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dynamicDocument.form.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dynamicDocument.form.name',
    accessorKey: 'name',
    variant: DataTableColumnVariant.TEXT,
    filter: { type: 'text' },
  };

  const orderColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dynamicDocument.form.order',
    accessorKey: 'dynaDocOrder',
    variant: DataTableColumnVariant.TEXT,
  };

  const marketTypeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dynamicDocument.form.marketType',
    accessorKey: 'typeMarche.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const modePassationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dynamicDocument.form.modePassation',
    accessorKey: 'modePassation.libelle',
    variant: DataTableColumnVariant.TEXT,
  };

  const dynaDocsModelColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dynamicDocument.form.dynaDocsModel',
    accessorKey: 'dynaDocsModel.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const isAAOColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'dynamicDocument.form.isAAO',
    accessorKey: 'isAAO',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value ? 'dynamicDocument.form.aao.oui' : 'dynamicDocument.form.aao.non' };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'info' : 'secondary';
      },
    },
    filter: {
      options: [
        { label: 'dynamicDocument.form.aao.oui', value: true },
        { label: 'dynamicDocument.form.aao.non', value: false },
      ],
      type: 'select',
      placeholder: 'Search by AAO',
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'dynamicDocument.form.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: DynaStatus) => {
      return { value: value == DynaStatus.ACTIF ? 'dynamicDocument.form.active' : 'dynamicDocument.form.inActive' };
    },
    props: {
      getSeverity: value => {
        return value == DynaStatus.ACTIF ? 'success' : 'danger';
      },
    },
    filter: {
      options: [
        { label: 'dynamicDocument.form.active', value: DynaStatus.ACTIF },
        { label: 'dynamicDocument.form.inActive', value: DynaStatus.NON_ACTIF },
      ],
      type: 'select',
      placeholder: 'Search by status',
    },
  };

  return {
    singular: 'dynamicDocument.form.create',
    plural: 'dac.form.title',
    columns: [idColumn, nameColumn, orderColumn, marketTypeColumn, modePassationColumn, dynaDocsModelColumn, isAAOColumn, statusColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    rowActions,
    enableFiltering: true,
    searchableFields: ['id', 'name', 'dynaDocOrder', 'typeMarche.description', 'modePassation.libelle'],
  };
};
